/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/asin.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Returns the arcsine of the input\nnumeric expression as an angle, expressed in radians.',
  examples: [
    'ROW a=.9\n| EVAL asin=ASIN(a)',
  ],
  params: {
    number: 'Number between -1 and 1. If `null`, the function returns `null`.',
  },
};

export default docs;
